module.exports = __webpack_public_path__ + "img/2_74.abc8a718.png";